(() => {
  const openDesktopFacets = (collection) => {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    collection.querySelectorAll('.facets__disclosure-vertical').forEach((details) => {
      if (details.dataset.collectionFacetInitialized === 'true') return;
      details.open = true;
      details.dataset.collectionFacetInitialized = 'true';
    });
  };

  const enhanceMobileFacets = (collection) => {
    const viewResultsLabel = collection.dataset.viewResultsLabel || 'View results';
    collection.querySelectorAll('.mobile-facets__footer .button--primary').forEach((button) => {
      if (button.textContent.trim() !== viewResultsLabel) button.textContent = viewResultsLabel;
      if (button.getAttribute('aria-label') !== viewResultsLabel) button.setAttribute('aria-label', viewResultsLabel);
    });

    const header = collection.querySelector('.mobile-facets__header-inner');
    if (!header || header.querySelector('[data-collection-filter-close]')) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'uc-collection__filter-close';
    button.dataset.collectionFilterClose = '';
    button.textContent = collection.dataset.filterCloseLabel || 'Close';
    button.addEventListener('click', () => {
      const nativeClose = collection.querySelector('.mobile-facets__close');
      if (nativeClose) nativeClose.click();
      else collection.querySelector('.mobile-facets__open-wrapper summary')?.click();
    });
    header.appendChild(button);
  };

  const disableCompatibilityFacets = (collection) => {
    const desktopForm = collection.querySelector('.uc-collection__facets-compat #FacetFiltersForm');
    if (desktopForm) desktopForm.id = 'FacetFiltersFormCompatibility';
    collection.querySelectorAll('.uc-collection__facets-compat input, .uc-collection__facets-compat select, .uc-collection__facets-compat button').forEach((control) => {
      control.disabled = true;
    });
  };

  const init = () => {
    document.querySelectorAll('[data-collection-v5]').forEach((collection) => {
      disableCompatibilityFacets(collection);
      openDesktopFacets(collection);
      enhanceMobileFacets(collection);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length > 0)) init();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
